import {DEBUG_STORAGE_ROOT_KEY} from './paginationTelemetry';

const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on', 'debug']);

const parseFlagValue = (rawValue) => {
  if (typeof rawValue === 'boolean') return rawValue;
  if (typeof rawValue === 'number') return rawValue === 1;
  const normalized = String(rawValue || '')
    .trim()
    .toLowerCase();
  return ENABLED_VALUES.has(normalized);
};

const readDebugRoot = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(DEBUG_STORAGE_ROOT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

/**
 * Check a top-level debug flag under `_debug.<namespace>`.
 *
 * Enable in console:
 *   localStorage.setItem('_debug', JSON.stringify({ blackline: true }))
 *
 * @param {string} namespace  e.g. 'blackline'
 * @returns {boolean}
 */
export const isDebugFlagEnabled = (namespace) => {
  const root = readDebugRoot();
  if (!root || !Object.prototype.hasOwnProperty.call(root, namespace)) {
    return false;
  }
  return parseFlagValue(root[namespace]);
};

/**
 * Snapshot of blackline debug flags for useDebugFlags integration.
 * @returns {{blackline: boolean}}
 */
export const getBlacklineDebugFlags = () => ({
  blackline: isDebugFlagEnabled('blackline'),
});
